import * as React from "react";
import { Text, TextVariant } from "../../ui";

const cardClassName = "w-full text-left border border-[#55697f] rounded-md bg-[#2b3a4f] overflow-hidden flex flex-col";

/** The frame every history card shares: a darker header bar with a title and an optional aside, then the body. */
export const HistoryCard: React.FC<{
  title: React.ReactNode;
  aside?: React.ReactNode;
  /** A second header line under the title and aside, full width, smaller and not bold. */
  subtitle?: React.ReactNode;
  id?: string;
  /** Outlined in blue, like a part order group opened from a job card, after a jump to it. */
  highlighted?: boolean;
}> = ({ title, aside, subtitle, id, highlighted, children }) => {
  const content = (
    <>
      <div className="bg-[#1f2b3a] border-b border-[#55697f] px-3 py-2 flex flex-col w-full">
        <div className="flex items-center justify-between gap-2">
          <Text variant={TextVariant.BODY2} as="div" style={{ fontWeight: 600, minWidth: 0 }}>
            {title}
          </Text>
          {aside}
        </div>
        {subtitle && (
          <Text variant={TextVariant.CAPTION} as="div" className="text-[#cbd5e1]">
            {subtitle}
          </Text>
        )}
      </div>
      {children}
    </>
  );
  return (
    <div id={id} className={`${cardClassName} ${highlighted ? "border-blue-400 ring-2 ring-blue-400/40" : ""}`}>
      {content}
    </div>
  );
};
